import React, { Component } from 'react'
import { Alert, Button, Card, Form, message, Select } from 'antd'
import EmailList from '../../Common/Contacts/EmailList'
import MobileList from '../../Common/Contacts/MobileList'
import PhoneList from '../../Common/Contacts/PhoneList'
import _ from 'lodash'

const FormItem = Form.Item
/*const Option = Select.Option*/

class Contact extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        console.log('234')
        let ss = await this.props.handleSubmit()
        ss && message.success('Updated')
      } else {
        message.error('Failed')
      }
    })
  }

  render() {
    const {
      formItemLayout,
      contact,
      loading,
      error,
      fetching,
      handleChange,
      handleAdd,
      handleDefault,
      handleRemove,
    } = this.props
    const { getFieldDecorator } = this.props.form

    console.log({ loading })
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 4,
        },
      },
    }
    return fetching ? (
      <Card loading={fetching} />
    ) : (
      <Form layout="vertical">
        <EmailList
          list={_.get(contact, 'email', [])}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
        <MobileList
          list={_.get(contact, 'mobile', [])}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
        <PhoneList
          list={_.get(contact, 'phone', [])}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />

        <PhoneList
          list={_.get(contact, 'fax', [])}
          handleChange={handleChange}
          getFieldDecorator={getFieldDecorator}
          formItemLayout={formItemLayout}
          handleDefault={handleDefault}
          title={'Fax'}
          handleRemove={handleRemove}
          handleAdd={handleAdd}
        />
        <FormItem {...tailFormItemLayout}>
          <p style={{ textAlign: 'right' }}>
            <Button loading={loading} type="primary" onClick={this.handleSubmit}>
              Update
            </Button>
          </p>
          {error.key ? (
            <Alert
              _key={error._key}
              message={error.message === '' ? 'failed!' : error.message}
              type="error"
              closable
            />
          ) : null}
        </FormItem>
      </Form>
    )
  }
}

const WrappedRegistrationForm = Form.create()(Contact)

export default WrappedRegistrationForm
